import React, { useState, useEffect } from 'react';
import CompanyItemComponent from '../../Company';

function ComponentConfirmMakeHotelInvoice(props) {
    const { data, type, group_id, invoice_id, typeInvoice } = props; //isAddService ,
    const [linkData, setLinkData] = useState("");

    // console.log("type", type)
    // console.log("typeInvoice ", typeInvoice )

    function renderButtonWithType() {
        switch (type) {
            case "redoInvoice":
                return (<div>
                    <button className="btn btn-primary"
                        onClick={props.onReload}>Confirm Redo</button>
                    <button className="btn btn-danger ml-2"
                        onClick={props.onClose}
                    >Cancel</button>
                </div>)
            case "roomOnWaitingList": 
                return (<div> <button className="btn btn-danger"
                    onClick={props.onClose}
                >Close & Reload</button> </div>)
            default:
                return (<div>
                    <button className="btn btn-primary"
                        onClick={props.onPrintAll}>{typeInvoice === "PMRQ" ? "Make All Schedule" : "Print All Schedule"}</button>
                        {
                            (typeInvoice !== "PMRQ" && typeInvoice !== "Booking") && <button className="btn btn-success ml-2"
                                  //disabled={!isAddService}
                            onClick={props.onOpenAddService} >Add Service</button>
                        }
                    <button className="btn btn-danger ml-2"
                        onClick={props.onClose}
                    >Cancel</button>
                </div>)
        }
    }

    useEffect(() => {
        setLinkData(group_id)
    }, [group_id])

    //console.log("type", type)
    
    return (<>
        {
            (type === "redoInvoice" || typeInvoice === "PMRQ" || typeInvoice === "Booking" ) ?
                ""
            : (typeInvoice === "roomOnWaitingList") ? <div>
                <h3>There is a schedule in [WAITING LIST] that matches the deleted schedule.</h3>
                <h4>* Có lịch trình ở [WAITING LIST] phù hợp với lịch trình đã bị xoá </h4>
            </div>
            :<>
                <div>
                <label>ID Group: </label>
                <input
                    className="mr-2 ml-2"
                    style={{ width: '100px' }}
                    value={linkData}
                    onChange={e => setLinkData(e.target.value)}></input>
                <button className="btn btn-primary"
                    onClick={() => props.onChange(linkData)}>Save</button>
                <button className="btn btn-success ml-2"
                    onClick={props.onReload}>Reload</button>
                </div>
                <span style={{ fontSize: '1rem', color: '#5f497a' }}>* Same ID group can connect other booking</span>
                <label style={{ width:'100%',fontSize: '1.3rem',  }}>Hotel invoice number: {invoice_id}</label>
            </>
        }

        <CompanyItemComponent
            type={type}
            data={data.data}
            search={data.search}
        />

        {renderButtonWithType() }

    </>)
}

export default ComponentConfirmMakeHotelInvoice;
